import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { recommendationsStateSelector } from "../../recommendationsStateSelector";

export const recommendationsReadyToRestoreSelector = createDraftSafeSelector(
  [recommendationsStateSelector],
  (state) => {
    return state.dismiss.resourcesReadyToRestore;
  },
);
